import type { SwiperOptions } from 'swiper/types'
import { Navigation, Pagination } from "swiper/modules"

export const teaserCardSliderOptions: SwiperOptions = {
  spaceBetween: 30,
  slidesPerGroup: 1,
  slidesPerView: 4,
  navigation: true,
  grabCursor: true,
  modules: [Pagination],
  // pagination: {
  //   clickable: true,
  //   type: 'bullets'
  // },
  injectStyles: [
    `
      .swiper {
        overflow: visible;
      }
      .swiper-button-prev, .swiper-button-next {
        position:static;
        width: 50px;
        height: 40px;
        border-radius: 8px;
        background: var(--yt-btn-slider-bg-color);
        svg {
          width: auto;
          height:auto;
        }
      }
        .swiper-button-prev {
          margin-top:1rem;
        }
      .swiper-button-next {
        position:relative;
        top: -18px;
        left:60px;
      }
      .swiper-pagination {
        padding: 30px;
        display: flex;
        position: relative;
        bottom: 0;
        gap: var(--swiper-pagination-bullet-horizontal-gap);
        justify-content: center;
      }
      .swiper-pagination-bullet {
        transition: width .2s ease-out, background-color 0.2s;
        --swiper-pagination-bullet-horizontal-gap: 0;
      }
      .swiper-pagination-bullet-active {
        width: 40px;
      }
    `
  ],
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 15
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    1190: {
      slidesPerView: 3
    },
    1320: {
      slidesPerView: 4
    },
    1600: {
      slidesPerView: 4
    }
  }
}
